<form class="kiosk-mode-booking-form" [formGroup]="form">
  <!-- ! Users will be added at a later point -->
  <!-- <div class="block">
  <label
    class="small-text-bold"
      i18n="
        @@booking-module|meeting-room-kiosk-booking-details|meeting-booking-for"
    >
    Booking for
  </label>
  <ng-container *ngIf="userViewInfoList$ | async as userViewInfoList">
    <db-skeleton-loader
      *ngIf="userViewInfoList === null"
      skeletonWidth="100%"
      skeletonHeight="58px"
    ></db-skeleton-loader>
    <db-user-item
      *ngIf="userViewInfoList.length && selectedUser"
      [user]="selectedUser"
    ></db-user-item>
    <db-dropdown-with-search-users
      *ngIf="userViewInfoList.length > 0"
      [users]="userViewInfoList"
      [selectedUserId]="(assignedUser?.id || selectedUser?.id)!"
      [isLoading]="false"
      [showUserEmail]="true"
        (selectedUserIdChange)="
          selectedUserChangedHandler($event, userViewInfoList)
        "
      [smallSelectedValue]="true"
      panelStyleClass="kiosk-dropdown-panel"
      dataTestId="kiosk--amr-event-form--booking-user-select-input"
    ></db-dropdown-with-search-users>
  </ng-container>
</div> -->

  <label i18n="@@meeting-rooms-kiosk|meeting-title-label" class="block"
    >Meeting title</label
  >
  <input
    class="w-full flex"
    pInputText
    type="text"
    formControlName="title"
    i18n-placeholder="@@meeting-rooms-kiosk|default-meeting-title-placeholder"
    placeholder="Add a title or select from the options below"
    data-testId="kiosk--amr-event-form--meeting-title-input"
  />

  @if (!form.value.title) {
    <div class="preset-options-container title-options">
      @for (presetOption of presetTitleOptions; track presetOption) {
        <div
          class="preset normal-text-bold"
          (click)="handlePresetNameSelection(presetOption)"
        >
          {{ presetOption.label }}
        </div>
      }
    </div>
  }

  <div class="time-pickers-container">
    <label>
      <ng-container i18n="@@meeting-room-booking-details-form|time-frame"
        >Time frame:
      </ng-container>
      <span
        class="text"
        i18n="@@meeting-room-booking-details-form|available-from-to"
      >
        Available from {{ firstAvailableTime }} to
        {{ slot.endTime | formatDateTime: "HH:mm" }}
      </span>
    </label>

    @if (!hasSelectedPresetTime) {
      <div class="preset-options-container">
        @for (presetOption of presetTimeOptions; track presetOption) {
          <div
            class="preset normal-text-bold"
            (click)="handlePresetTimeSelection(presetOption)"
          >
            {{ presetOption.label }}
          </div>
        }
      </div>
    }
    @if (hasSelectedPresetTime) {
      <div class="time-pickers-line">
        <div class="time-picker-wrapper start-time">
          <db-time-picker-control
            formControlName="startTime"
            [timeFormat]="timeFormatNumber"
            [minutes]="5"
            [editable]="false"
            [disabledTimeValues]="(startTimeDisabledTimes$ | async)!"
            [is24hoursPossible]="false"
            label=" "
            (ngModelChange)="handleTimeSelection('start')"
          >
          </db-time-picker-control>
        </div>
        <div class="time-picker-wrapper end-time">
          <db-time-picker-control
            formControlName="endTime"
            [timeFormat]="timeFormatNumber"
            [minutes]="5"
            [editable]="false"
            label=" "
            [disabledTimeValues]="(endTimeDisabledTimes$ | async)!"
            [is24hoursPossible]="false"
            (ngModelChange)="handleTimeSelection('end')"
          >
          </db-time-picker-control>
        </div>
      </div>
    }
    @if (areTimesEqual) {
      <div
        class="text-danger"
        i18n="@@meeting-room-booking-details-form|same-times-error-msg"
      >
        Start time and end time cannot be equal
      </div>
    }
  </div>
</form>
